import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Калъфки за възглавници от 100% памук | Размери по поръчка | GoToBed',
  description:
    'Калъфки за възглавници от 100% памук в стандартни и нестандартни размери. Ранфорс и памучен сатен, изработка по поръчка. Поръчайте онлайн от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Калъфки за възглавници от 100% памук
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Калъфки за възглавници от 100% памук в голямо разнообразие от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще откриете калъфки за възглавници от 100% памук в едноцветни и шарени (с
          принт) десени, които се изработват по поръчка и се предлагат в голямо разнообразие от
          размери. Това позволява лесно да намерите подходяща калъфка както за стандартни, така и за
          ортопедични или нестандартни възглавници. Сред най-популярните размери са 40/60, 50/70,
          60/80 и 70/90, изработени от качествени памучни материи ранфорс и памучен сатен.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyKalufki />;
}

function SeoBodyKalufki() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Калъфки за възглавници от 100% памук в различни размери */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Калъфки за възглавници от 100% памук в различни размери
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Калъфките за възглавници от 100% памук са важна част от всяко спално бельо, защото
        осигуряват комфорт по време на сън и завършен вид на спалнята. В нашия онлайн магазин ще
        откриете калъфки за възглавници от 100% памук – естествена материя, която е дишаща, приятна
        на допир и подходяща за ежедневна употреба. Нашите памучни калъфки за възглавници съчетават
        естествен комфорт, издръжливост и богат избор от размери.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Предлагаме калъфки от висококачествени памучни платове като ранфорс и памучен сатен, които
        се отличават с мекота, здравина и дълготрайни цветове. В категорията ще намерите както
        едноцветни, така и шарени калъфки, подходящи за различни стилове спално бельо.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Всички калъфки се изработват по индивидуална поръчка според избраните от клиента параметри.
        Можете да поръчате както стандартни, така и нестандартни размери, така че калъфката да пасне
        точно на вашата възглавница.
      </Typography>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Материи за калъфки за възглавници */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Материи за калъфки за възглавници
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Нашите калъфки се изработват от висококачествени памучни материи, които осигуряват комфорт
          и дълготрайност.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ранфорсът е плътен и издръжлив памучен плат, който е много подходящ за ежедневна употреба.
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            вижте всички калъфки за възглавници ранфорс
          </Typography>
        </Box>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Памучният сатен е по-фин и гладък памучен плат с лек блясък и по-луксозно усещане.
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            вижте всички калъфки за възглавници памучен сатен
          </Typography>
        </Box>

        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          И двата вида плат са 100% памук и са сертифицирани по OEKO-TEX Standard 100, което
          гарантира безопасност и високо качество на текстила.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако искате да комбинирате калъфките с останалото спално бельо, можете да разгледате и:
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/plikove-za-zavivka/1/4"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            пликове за завивки
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi-s-lastik/1/3"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi/1/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи
          </Typography>
        </Box>

        {/* H2: Налични размери калъфки за възглавници */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Налични размери калъфки за възглавници
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Калъфките могат да бъдат изработени в следните размери.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Правоъгълни размери
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '50/70',
            '50/75',
            '50/80',
            '53/73',
            '55/75',
            '60/70',
            '60/80',
            '60/90',
            '60/100',
            '40/60',
            '40/50',
            '43/63',
            '48/68',
            '35/53',
            '33/66',
            '37/47',
            '33/43',
            '54/63',
            '54/71',
            '54/74',
            '54/76',
            '54/82',
            '54/99',
            '57/87',
            '57/114',
            '39/99'
          ].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Размери за дълги възглавници
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {['54/145', '54/165', '54/185'].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Квадратни размери
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '82/82',
            '70/70',
            '65/65',
            '60/60',
            '55/55',
            '50/50',
            '45/45',
            '40/40',
            '35/35',
            '30/30 см'
          ].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>

        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ако вашата възглавница е с различен размер, можем да изработим калъфка и по индивидуална
          поръчка.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За да създадете напълно съчетан комплект спално бельо, можете да комбинирате калъфките с:
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/plikove-za-zavivka/1/4"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            пликове за завивки
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi-s-lastik/1/3"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi/1/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи
          </Typography>
        </Box>

        {/* H2: Популярни размери калъфки за възглавници */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери калъфки за възглавници
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Тук ще откриете калъфки за възглавници в голямо разнообразие от размери, подходящи за
          различни видове възглавници.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Сред най-търсените размери са:
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>калъфка за възглавница 50/70 (50х70)</li>
          <li>калъфка за възглавница 60/80 (60х80)</li>
          <li>калъфка за възглавница 60/90 (60х90)</li>
          <li>калъфка за възглавница 70/70 (70х70)</li>
          <li>калъфка за възглавница 40/60 (40х60)</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Всички модели се изработват от 100% памук – ранфорс или памучен сатен – и могат да бъдат
          съчетани с:
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/plikove-za-zavivka/1/4"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            пликове за завивки
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi/1/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi-s-lastik/1/3"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик
          </Typography>
        </Box>

        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography variant="body1" sx={{ mb: 1.5, color: 'text.secondary' }}>
            <strong>Калъфка за възглавница 50/70 (50х70) см</strong>
            <br />
            Калъфките за възглавници 50/70 са сред най-използваните размери за стандартни
            възглавници. В нашия магазин можете да поръчате калъфка 50/70 от 100% памук – ранфорс
            или памучен сатен.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5, color: 'text.secondary' }}>
            <strong>Калъфка за възглавница 60/80 (60х80) см</strong>
            <br />
            Калъфките за възглавници 60/80 са подходящи за по-големи или ортопедични възглавници.
            Предлагаме калъфки 60/80 от 100% памук, които осигуряват комфорт и добра дишаемост.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5, color: 'text.secondary' }}>
            <strong>Калъфки за ортопедични възглавници</strong>
            <br />
            Ако използвате ортопедична възглавница, е важно калъфката да бъде в подходящ размер.
            Предлагаме калъфки за ортопедични възглавници в различни размери, които могат да бъдат
            изработени по поръчка.
          </Typography>
        </Box>

        {/* H2: Калъфки за възглавници според материята */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Калъфки за възглавници според материята
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Можете да изберете калъфки за възглавници от различни 100% памучни материи, които
          съчетават комфорт, издръжливост и стил.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Сред най-предпочитаните варианти са:
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>калъфки за възглавници 50/70 ранфорс</li>
          <li>калъфки за възглавници 60/80 ранфорс</li>
          <li>калъфки за възглавници 50/70 памучен сатен</li>
          <li>калъфки за възглавници 60/80 памучен сатен</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Разгледайте всички модели тук:
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници памучен сатен
          </Typography>
        </Box>

        {/* H2: Как да изберете подходяща калъфка за възглавница */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Как да изберете подходяща калъфка за възглавница
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          При избора на калъфка за възглавница е важно да се съобразите с размера и формата на
          възглавницата. Предлагаме калъфки в множество стандартни и нестандартни размери, което
          позволява лесно да намерите подходящия вариант. Можете да изберете между материи като
          ранфорс и памучен сатен, в едноцветни или шарени десени.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за калъфките за възглавници
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какви размери калъфки за възглавници предлагате?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Предлагаме калъфки за възглавници в голямо разнообразие от размери – както стандартни,
            така и нестандартни. Калъфките могат да бъдат изработени в различни размери,
            включително: Калъфки за възглавници размери 50/70, 60/80 и 70/90. Това са едни от
            най-разпространените размери на възглавници. В нашия онлайн магазин можете да поръчате
            калъфки за възглавници с размери 50/70, 60/80, 60/90, 70/70, 40/60 и други популярни
            размери, изработени от 100% памук.
          </Typography>
          <Box sx={{ pl: 2 }}>
            <Typography
              variant="body1"
              component={Link}
              to="/kategorii/spalno-belio/plikove-za-zavivka/1/4"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              пликове за завивки
            </Typography>
            <Typography
              variant="body1"
              component={Link}
              to="/kategorii/spalno-belio/charshafi/1/1"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              чаршафи
            </Typography>
            <Typography
              variant="body1"
              component={Link}
              to="/kategorii/spalno-belio/charshafi-s-lastik/1/3"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              чаршафи с ластик
            </Typography>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Калъфки за възглавници с нестандартни размери
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Освен стандартните размери предлагаме и калъфки за възглавници с нестандартни размери,
            като: 33/43, 37/47, 35/53, 43/63, 48/68, 54/71, 54/74, 57/87 и други. Това позволява да
            поръчате калъфка, която пасва точно на вашата възглавница.
          </Typography>
          <Box sx={{ pl: 2 }}>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/kalufki/1/2/2"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              калъфки ранфорс
            </Typography>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/kalufki/1/2/1"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              калъфки памучен сатен
            </Typography>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Калъфки за дълги възглавници
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            При нас можете да поръчате и калъфки за дълги възглавници (body pillow). Предлагаме
            размери като: 54/145, 54/165, 54/185. Тези размери са подходящи за дълги възглавници за
            сън или декоративни възглавници.
          </Typography>
          <Box sx={{ pl: 2 }}>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/plikove-za-zavivka/1/4/2"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              пликове за завивки ранфорс
            </Typography>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/plikove-za-zavivka/1/4/1"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              пликове за завивки памучен сатен
            </Typography>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер калъфка за възглавница?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            За да изберете правилния размер калъфка, е необходимо да измерите вашата възглавница –
            нейната ширина и дължина. Калъфката трябва да съответства на размера на възглавницата,
            за да прилепва добре и да осигурява комфорт по време на сън. Важно е калъфката да бъде
            достатъчно свободна, за да не притиска и деформира възглавницата. Ако калъфката е
            прекалено малка, тя може да промени формата и обема на възглавницата. От друга страна,
            прекалено голямата калъфка може да се набръчква и да създава неудобство при използване.
          </Typography>
          <Box sx={{ pl: 2 }}>
            <Typography
              variant="body1"
              component={Link}
              to="/kategorii/spalno-belio/plikove-za-zavivka/1/4"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              пликове за завивки
            </Typography>
            <Typography
              variant="body1"
              component={Link}
              to="/kategorii/spalno-belio/charshafi/1/1"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              чаршафи
            </Typography>
            <Typography
              variant="body1"
              component={Link}
              to="/kategorii/spalno-belio/charshafi-s-lastik/1/3"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              чаршафи с ластик
            </Typography>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            От какъв плат са изработени калъфките за възглавници?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Калъфките се изработват от 100% памук, като можете да избирате между две основни материи
            – ранфорс и памучен сатен.
          </Typography>
          <Box sx={{ pl: 2 }}>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/kalufki/1/2/2"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              калъфки ранфорс
            </Typography>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/kalufki/1/2/1"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              калъфки памучен сатен
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ mt: 1, color: 'text.secondary' }}>
            И двата плата са естествени, дишащи и приятни на допир, което ги прави подходящи за
            ежедневно използване.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Каква е разликата между ранфорс и памучен сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Ранфорсът и памучният сатен са висококачествени памучни тъкани, които често се използват
            за изработка на спално бельо. Ранфорсът е памучна материя с класическо тъкане. Той има
            равномерна структура, приятна мекота и добра издръжливост, което го прави много подходящ
            за ежедневно спално бельо. Памучният сатен се тъче по специална техника, която прави
            плата по-гладък и по-фин на допир. Той има лек естествен блясък и придава по-елегантен
            вид на спалното бельо.
          </Typography>
          <Box sx={{ pl: 2 }}>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/plikove-za-zavivka/1/4/2"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              пликове за завивки ранфорс
            </Typography>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/plikove-za-zavivka/1/4/1"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              пликове за завивки памучен сатен
            </Typography>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свиват ли се памучните калъфки при пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Памучните платове могат да имат естествена свиваемост до около 4–5% при пране. При
            сушене в сушилня свиването може да бъде по-голямо, особено при по-висока температура.
            Затова при по-високи или по-плътни възглавници е препоръчително да се предвиди малко
            по-голям размер на калъфката.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Могат ли калъфките да се изработят по индивидуален размер?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Всички калъфки за възглавници в нашия онлайн магазин се изработват по индивидуална
            поръчка, според избраните размери и параметри. Това означава, че всяка калъфка се ушива
            специално за конкретната поръчка, което позволява да предложим голям избор от стандартни
            и нестандартни размери.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            За колко време се изработват калъфките за възглавници?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Калъфките се изработват ръчно според избраните от клиента параметри. Обичайният срок за
            изработка е между 3 и 10 работни дни, като в повечето случаи поръчките се изпълняват в
            рамките на 4–7 работни дни. Ако не сте сигурни кой размер да изберете, можете да се
            свържете с нас и ще ви помогнем да изберете най-подходящия размер калъфка за вашата
            възглавница.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
